import { render, staticRenderFns } from "./OfficeStampEditPage.vue?vue&type=template&id=03752336&"
import script from "./OfficeStampEditPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeStampEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports